export const bytesToSize = bytes => {
  if (!bytes || Number.isNaN(bytes)) {
    return "0 B";
  }

  const parsedBytes = Number(bytes);
  if (parsedBytes === 0) {
    return "0 B";
  }

  const units = ["B", "KB", "MB", "GB", "TB"];
  const exponent = Math.floor(Math.log(parsedBytes) / Math.log(1024));
  const normalized = parsedBytes / Math.pow(1024, exponent);

  return `${normalized.toFixed(normalized >= 10 || normalized % 1 === 0 ? 0 : 1)} ${units[exponent]}`;
};



